import { render, staticRenderFns } from "./EditState.vue?vue&type=template&id=2b0c463e"
import script from "./EditState.vue?vue&type=script&lang=js"
export * from "./EditState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports